import React from "react";
import "./index.less";
import { hasFlag } from "country-flag-icons";
const FlagComponent = ({ type, ...props }: any) => {
  const icons = require(`country-flag-icons/react/3x2`);
  let has = hasFlag(type);
  if (!has) {
    const Component = icons["US" as string];
    return <Component {...props} className="flag" />;
  }
  const Component = icons[type as string];
  return <Component {...props} className="flag" />;
};

export default FlagComponent;
